/**
 * Home / favorite station preference.
 * Also tracks a "returning listener" flag — set after the first successful
 * playback — used by Landing.jsx to silently autoplay for returning fans.
 */
const KEY = "gfn_home_station";
const TOAST_KEY = "gfn_home_toast_shown"; // sessionStorage — show once per session
const RETURNING_KEY = "gfn_returning_listener";

export function getHomeStation() {
  try {
    return localStorage.getItem(KEY) || null;
  } catch {
    return null;
  }
}

export function setHomeStation(id) {
  try {
    if (id) localStorage.setItem(KEY, id);
    else localStorage.removeItem(KEY);
  } catch {}
}

export function toggleHomeStation(id) {
  const current = getHomeStation();
  const next = current === id ? null : id;
  setHomeStation(next);
  return next;
}

export function markHomeToastShown() {
  try {
    sessionStorage.setItem(TOAST_KEY, "1");
  } catch {}
}

export function wasHomeToastShown() {
  try {
    return !!sessionStorage.getItem(TOAST_KEY);
  } catch {
    return false;
  }
}

export function markReturningListener() {
  try {
    localStorage.setItem(RETURNING_KEY, "1");
  } catch {}
}

export function isReturningListener() {
  try {
    return !!localStorage.getItem(RETURNING_KEY);
  } catch {
    return false;
  }
}
